import { defineStore } from 'pinia';
import API from '@/shared/helpers/API.js';
import {useUserStore} from "@/console-new/stores/user.store";

export const useKitchenMonitorsStore = defineStore('kitchenmonitors', {
	state: () => ({
		stations: [],
		stationsMap: {},
	}),
	actions: {
		kitchenStationUpdateExcludedCategories(businessId, stationId, categories, callback = null) {
			let userStore = useUserStore();
			if(!userStore.currBusinessId) { return; }
			API.init().kitchenStationUpdateExcludedCategories(businessId, stationId, JSON.stringify(categories), response => {
				if(response && response.result === "OK") {
					this.getBusinessStations(callback, true);
				} else {
					callback && callback(false);
				}
			});
		},
		getBusinessStations(callback = null, force = false) {
			if(!force && this.stations?.length) { callback && callback(this.stations); return; }

			let userStore = useUserStore();
			if(!userStore.currBusinessId) { return; }
			API.init().getKitchenStations(userStore.currBusinessId, response => {
				this.stations = [];
				this.stationsMap = {};
				let fetchedExcludedCategories = [];
				if (response && response.result === "OK") {
					if(response?.categories_excl && response.categories_excl?.length) {
						fetchedExcludedCategories = response.categories_excl;
					}
					if(response.stations && response.stations.length > 0) {
						response.stations.forEach(fetchedStation => {
							let parsedStation = this.normalizeStation(fetchedStation);
							if(!this.stationsMap[parsedStation.user_id]) {
								let stationExcludedCategories = fetchedExcludedCategories.filter(excludedCategory => Number(excludedCategory.user_id) === parsedStation.user_id);
								stationExcludedCategories.forEach(excludedCategory => {
									let parsedExcludedCategory = this.normalizeExclCategory(excludedCategory);
									parsedStation.exclude_categories[parsedExcludedCategory.menu_category_id] = parsedExcludedCategory;
								});
								this.stations.push(parsedStation);
								this.stationsMap[parsedStation.user_id] = parsedStation;

							}
						});
					}
				}
				callback && callback(this.stations);
			});
		},
		getExcludedCategories(callback = null, force = false) {
			if(!useUserStore().currBusinessId || !useUserStore().user || !useUserStore().user.user_id) {
				callback && callback(false);
			}
			let userId = Number(useUserStore().user.user_id);
			if(!force && this.stationsMap[userId]?.exclude_categories) {
				callback && callback(this.stationsMap[userId].exclude_categories);
				return;
			}
			API.init().getKitchenStationExcludedCategories(useUserStore().currBusinessId, response => {
				let fetchedExcludedCategories = [];
				if (response && response.result === "OK") {
					if(response.categories_excl && response.categories_excl.length) {
						fetchedExcludedCategories = response.categories_excl;
					}
					if(!this.stationsMap[userId]) {
						this.stationsMap[userId] = this.normalizeStation({
							business_id: Number(useUserStore().currBusinessId),
							user_id: userId,
							station: true,
						});
					}
					this.stationsMap[userId].exclude_categories = {};
					fetchedExcludedCategories.forEach(excludedCategory => {
						let parsedExcludedCategory = this.normalizeExclCategory(excludedCategory);
						this.stationsMap[userId].exclude_categories[parsedExcludedCategory.menu_category_id] = parsedExcludedCategory;
					});
					callback && callback(this.stationsMap[userId].exclude_categories);
				} else {
					callback && callback(false);
				}
			});
		},
		normalizeStation(fetchedStation) {
			return {
				...fetchedStation,
				business_id: Number(useUserStore().currBusinessId),
				user_id: Number(fetchedStation.user_id),
				station: true,
				exclude_categories: {}
			}
		},
		normalizeExclCategory(fetchedCategory) {
			return {
				...fetchedCategory,
				user_id: Number(fetchedCategory.user_id),
				menu_category_id: Number(fetchedCategory.menu_category_id),
				print_small: fetchedCategory.print_small === 1,
			}
		},
		stationFilteredOrderGroup(stationId, orderGroup) {
			if (!orderGroup || !orderGroup.orders || !orderGroup.orders.length) { return null; }
			let returningOrders = [];
			orderGroup.orders.forEach(order => {
				let filteredItems = this.stationFilteredOrderItems(stationId, order);
				if(filteredItems.length) {
					returningOrders.push({...order, items: filteredItems});
				}
			});
			return returningOrders.length ? {...orderGroup, orders: returningOrders} : null;
		},
		stationFilteredOrderItems(stationId, order) {
			if(!order || !order.items || !order.items.length || !order.items.filter) { return []; }
			let stationExcludedCategories = this.stationsMap[stationId]?.exclude_categories;
			if(!stationExcludedCategories) { return order.items; }
			let finalItems = order.items.filter(item => {
				if(!item.category_id) { return true; }
				return !stationExcludedCategories[item.category_id] || stationExcludedCategories[item.category_id]?.print_small;
			});
			for (let i = 0; i < finalItems.length; i++) {
				let item = finalItems[i];
				if(stationExcludedCategories[item.category_id]?.print_small) {
					item.print_small = true;
				}
			}
			return finalItems;
		},
	}
});
